import IMApis from './IMApis';
import C2S from './IMC2S';
import roomC2S from './roomC2S';
import IMConversation from './IMConversation';
import IMEventEmitter from './IMEventEmitter';
import SingleCountEmitter, { IMEvent } from './IMEventEmitter';
import IMGroups from './IMGroups';
import IMMessage from './IMMessage';
import MessageType from './IMMessageType';
import StringUtils from './IMStringUtils';
import IMPinyin from './IMPinyin';
import IMUtils from './IMUtils';
import IMSocketMgr from './IMSocketMgr'
import axios from 'axios';
import AppUtils from '../control/apputlis';
import AppConfig from '../control/config';
import Long from 'long'
import Profile from '../control/Profile'


export default class IMApp {

    static server = [];
    static aliasList = [];
    static applylist = [];
    static friendlist = [];
    static inputSync = [];
    static muteList = [];
    static chatTopList = [];
    static deleteMsgList = [];
    static blackfriendlist = [];
    static ratelist = [];
    static saveDocs = [];
    static is15None = false; //是否15秒内收不到socket连接  
    static refreshRoom = true; //是否15秒内收不到socket连接  

    static user = {};
    static groupNickNames = {};

    static shareurl = '';
    static fastkey = '';
    static downurlcode = '';
    static imApi = Profile.imApi
    static imUploadApi = 'http://frljk.imtgb.cn/upload/upload.php';
    static channelid = (process.env.REACT_APP_ENV == 'production') ? '3' : '5';
    static version = '1.0'; //这里别改，后端通过这个来决定是否h5，是否给聊天记录 
    static deviceid = IMUtils.getUniqueID();
    static hostApi = IMApp.getUrl();
    static errDomainIndex = 0;
    static isLoginOther = false;
    static isInitHostApi = false;

    static checking = 0;

    static debugOrderId = false;
    static isAlone = false;
    static isPlaySound = false;
    static isChatVoiceIng = false;
    static isAppWeb = false;

    static pfid = 1;
    static server_time = IMApp.currentTime();
    static localTime = IMApp.server_time;
    static friendlistversion = 0;
    static unread_apply_num = 0;
    static msg_send_loading_time = 10000;
    static conversationId = 0;
    /** 消息过期时间 */
    static messageTimeOut = 5 * 60 * 60;
    static TXDOMAINCFG = Profile.imTencent;
    static ALDOMAINCFG = Profile.imAliyun;

    static getUrl() {
        //第一次进来，获取历史的baseurl
        let url = AppUtils.getStorageItem('DOMAIN_LIST_IM');
        if (url == null || url == undefined || url == '') {
            url = IMApp.imApi[Math.floor(Math.random() * IMApp.imApi.length)];
        }
        if (url[url.length - 1] != '/') {
            url = url + '/';
        }
        console.log('IMgetUrl===>', url);
        IMApp.checkDomains();
        return url;
    }
    static checkDomains() {
        IMApp.checkHttp(IMApp.imApi, true);
    }

    static checkHttp(domains, con) {
        for (let i = 0; i < domains.length; i++) {
            //循环发送网络请求
            IMApp.pingDomain(domains[i], domains.length, con);
        }
    }

    static pingDomain(url, len, con) {
        if (url[url.length - 1] != '/') {
            url = url + '/';
        }
        let formData = new FormData();
        let d = JSON.stringify({
            method: url,
            siteid: IMApp.channelid,
            version: IMApp.version,
            deviceid: IMApp.deviceid,
            channel: AppConfig.freeLanchannelid,
            // ip: IMApp.hostApi,
        })
        formData.append(
            'win_param',
            d,
        );
        let u = url + "api/flashapi.php";
        fetch(u, {
            method: 'POST',
            body: formData,
        }).then(response => {

            try {

                if (response && response.status == 200) {
                    //如果banseurl没设置过，去设置
                    if (!IMApp.isInitHostApi) {
                        AppUtils.setStorageItem('DOMAIN_LIST_IM', url);
                        IMApp.hostApi = url;
                        IMApp.isInitHostApi = true;
                        console.log('IMhostApi===>', url);
                    }
                }

            } catch (error) {
                IMApp.errDomainIndex++;
                if (len == IMApp.errDomainIndex && con) {
                    IMApp.getTxDomains();
                }
            }
        }).catch(e => {
            IMApp.errDomainIndex++;
            if (len == IMApp.errDomainIndex && con) {
                IMApp.getTxDomains();
            }
        });


    }

    static getTxDomains() {
        IMApp.getDomains(IMApp.TXDOMAINCFG)
    }
    static getAlDomains() {
        IMApp.getDomains(IMApp.ALDOMAINCFG)
    }

    static getDomains(u) {
        let to = u == IMApp.TXDOMAINCFG;
        axios.get(u).then(response => {
            try {
                let d = response[AppConfig.appID];
                IMApp.errDomainIndex = 0;
                IMApp.checkHttp(d, false);
            } catch (error) {
                if (to) {
                    IMApp.getAlDomains();
                }
            }
        }).catch(err => {
            if (to) {
                IMApp.getAlDomains();
            }
        })
    }

    static setAppWeb(isAppWeb) {
        IMApp.isAppWeb = isAppWeb;
    }

    static getFriendList() {
        return IMApp.friendlist;
    }

    static getGroupList() {
        return IMGroups.getGroups()
    }

    static getApplyFriendList() {
        return new Promise((resolve, _) => {
            IMEventEmitter.once(IMEvent.FRIEND_APPLY_LIST, () => {
                resolve(IMApp.applylist);
            })
            C2S.msg_friend_apply_list();
        });
    }

    static getUserInfoByUid(uid) {
        return new Promise((resolve, _) => {
            IMEventEmitter.once(IMEvent.S2C_MSG_GET_USER_INFO_REP, (msg) => {
                resolve(msg);
            })
            C2S.msg_get_user_info("", uid, 0);
        });
    }

    static applyFriend(uid, handletype) {
        return new Promise((resolve, _) => {
            IMEventEmitter.once(IMEvent.FRIEND_APPLY_BACK, (msg) => {
                if (msg.result == 1) {
                    C2S.msg_friend_list();
                    let content = '我通过了您的好友申请';
                    let chatkey = IMApp.createChatKey(msg.otheruid, IMApp.user.uid);
                    let m = IMApp.generateMsgOut(MessageType.TXT, content, chatkey, true, 1)
                    C2S.msg_send_private_msg(chatkey, MessageType.TXT, content, false, m.chatmsgno + '');
                }
                resolve(msg);
            })
            C2S.msg_handle_friend_apply(uid, handletype);
        });
    }

    static getConversationList() {
        return new Promise((resolve, _) => {
            let conversationList = IMConversation.getConversations();
            resolve(conversationList)
        })
    }

    static getConversation(conversationId) {
        return IMConversation.getConversation(conversationId);
    }

    static getChatRoomList() {
        return new Promise((resolve, reject) => {
            IMEventEmitter.once(IMEvent.CHAT_ROOM_LIST, (msg) => {
                if (msg.result == 1) {
                    resolve(msg);
                } else {
                    reject(msg);
                }
            })
            C2S.msg_get_chatroom_list();
        })
    }

    static getConversationMessageList(conversationId) {
        return IMMessage.getConversationMessageList(conversationId);
    }
    static setConversationMessageItem(conversationId, redBagId, type) {
        IMMessage.setConversationMessageItem(conversationId, redBagId, type);
    }

    static sendMessage(recvuid, msg_type, content, isGroup = false, clientkey = '', authcode = '', nopush = 0) {
        console.log('--------发送消息');

        C2S.msg_send_private_msg(recvuid, msg_type, content, isGroup, clientkey, authcode, nopush);
        let chatmsgno = IMMessage.getChatMsgNo(recvuid);
        return IMApp.buildMessage(recvuid, chatmsgno, content, isGroup, msg_type);
    }

    static roomMessage(recvuid, msg_type, content, isGroup = false, clientkey = '', authcode = '', nopush = 0) {
        console.log('--------发送消息');

        roomC2S.msg_send_private_msg(recvuid, msg_type, content, isGroup, clientkey, authcode, nopush);
        let chatmsgno = IMMessage.getChatMsgNo(recvuid);
        return IMApp.buildMessage(recvuid, chatmsgno, content, isGroup, msg_type);
    }

    static openRedBag(id) {
        //打开红包
        //发送网络请求
        C2S.msg_get_redbag(id)
    }

    static getRoomHistoryMsg(id) {

        roomC2S.get_room_history_msg(id)
    }

    static RedBagInfo(id) {
        //打开红包
        C2S.msg_get_redbag_info(id)
    }

    static sendChatRoomMessage(chatRoomId, msgType, content) {
        roomC2S.msg_send_chatroom_msg(chatRoomId, msgType, content);
        let chatmsgno = IMMessage.getChatMsgNo(chatRoomId);
        return IMApp.buildMessage(chatRoomId, chatmsgno, content, true, msgType);

    }

    static sendImageMessage(recvuid, file, isGroup = false) {
        return new Promise((resolve, reject) => {
            IMApis.uploadFile(file, (err, image) => {
                console.log('sendImageMessage==>', image);
                if (!err) {
                    if (image.ret == 0) {
                        let img = new Image();
                        img.src = image.fileurl;
                        img.onload = function () {
                            let content = { url: image.fileurl, width: img.width, height: img.height, size: file.size, time: file.lastModified, filename: file.name };
                            let result = IMApp.sendMessage(recvuid, MessageType.IMAGE, JSON.stringify(content), isGroup);
                            resolve(result);
                        }
                    } else {
                        reject(image);
                    }
                } else {
                    reject(err);
                }
            });
        })
    }

    static joinGroup(groupKey) {
        // return new Promise((resolve, reject) => { 
        //     IMEventEmitter.once(IMEvent.JOIN_ROOM_CHAT_REP, (msg) => { 
        //         if (msg.result == 1 || msg.result == 35) {
        //             // IMApp.sendMessage(groupKey, MessageType.CENTER_TIP_GROUP_CODE, JSON.stringify({}), true);
        //             resolve(msg); 
        //         } else {
        //             reject(msg);
        //         }
        //     });
        //     roomC2S.msg_join_chatroom(groupKey);
        // });
        roomC2S.msg_join_chatroom(groupKey);
    }

    static quitGroup(groupKey) {
        return new Promise((resolve, reject) => {
            C2S.msg_quit_chatroom(groupKey);
            IMEventEmitter.once(IMEvent.QUIT_ROOM_CHAT_REP, (msg) => {
                if (msg.result == 1 || msg.result == 36) {
                    resolve(msg);
                } else {
                    reject(msg);
                }
            })
        });
    }

    static setMessageRead(conversationId) {
        let messageList = IMApp.getConversationMessageList(conversationId);
        let msgNoList = [];
        messageList.forEach(element => {
            msgNoList.push(element.chatmsgno);
        });
        C2S.msg_confirm_hasread_msg(conversationId, msgNoList);
        IMConversation.clearUnReadCount(conversationId);
        SingleCountEmitter.emit(IMEvent.EVENT_MESSAGE_UNREAD_COUNT_CHANGE);
    }

    static setMessageHasRead(chatKey, msgNoList) {
        C2S.msg_confirm_hasread_msg(chatKey, msgNoList);
        IMConversation.clearUnReadCount(chatKey);
        SingleCountEmitter.emit(IMEvent.EVENT_MESSAGE_UNREAD_COUNT_CHANGE);
    }

    static createChatKey(uid, otheruid) {
        let isString = typeof uid == "string"
        if (isString) {
            uid = parseInt(uid)
        }
        if (uid < otheruid) {
            return Long.fromValue(uid * Math.pow(2, 32)).add(Long.fromValue(otheruid));
        } else {
            return Long.fromValue(uid).add(Long.fromValue(otheruid * Math.pow(2, 32)));
        }
    }

    static loadData(result) {
        IMApp.server = result.server;
        IMApp.user = result.user;
        IMApp.checking = result.checking;
        IMApp.downurlcode = result.downurlcode;
        IMApp.fastkey = result.fastkey;
        IMApp.pushurl = result.pushurl;
        IMApp.shareurl = result.shareurl;
    }

    static getServer() {
        if (IMApp.server.length > 0) {
            return IMApp.server[0];
        }
        return null;
    }

    static currentTime() {
        return Date.parse(new Date()) / 1000;
    }

    static getCurTime() {
        return (IMApp.server_time + (new Date().getTime() / 1000 - IMApp.localTime));
    }

    static getOtherId(chatkey, uid) {
        let isString = typeof chatkey == "string"
        if (isString) {
            chatkey = Long.fromString(chatkey)
        } else {
            chatkey = Long.fromValue(chatkey)
        }
        if (chatkey.high == uid) {
            return chatkey.low;
        }

        return chatkey.high;
    }

    static getSnapTime(conversationId) {
        let cLimit = 0;
        return cLimit;
    }

    static parseInfo(f) {
        let d = {};
        d.uid = f.uid;
        d.fid = f.fid;
        d.nickname = StringUtils.decode(f.nickname);
        d.phone = StringUtils.decode(f.phonenum);
        d.lastlogouttime = f.lastlogouttime;
        d.sign = StringUtils.decode(f.sign);
        d.region = StringUtils.decode(f.region);
        d.headurl = StringUtils.decode(f.headurl);
        IMApp.getPinyin(d);
        return d;
    }

    static getPinyin(d) {
        d.pinyin = IMPinyin.convertPinyin(d.nickname).toUpperCase();
        var firstLetter = d.pinyin.substring(0, 1);
        if (firstLetter < 'A' || firstLetter > 'Z') {
            firstLetter = '#';
        }
        d.firstLetter = firstLetter;
    }

    static getShowNameByUID(uid, chatkey) {

        return null;
    }

    static setValue(array, chatkey, opertime) {
        array.push({ chatkey: chatkey, opertime: opertime });
    }

    static getValue(array, chatkey) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].chatkey === chatkey) {
                return array[i].opertime;
            }
        }
        return 0;
    }

    static addDeleteMsg(chatkey, chatmsgno) {
        let d = {};
        d[chatkey] = chatmsgno;
        IMApp.deleteMsgList[chatkey] = chatmsgno;
    }

    static getAlias(uid) {
        return IMApp.aliasList[uid];
    }

    static checkIsGroup(chatkey) {
        return chatkey < 2147483647;
    }

    static getGroupNickName(groupkey, uid) {
        let info = IMApp.groupNickNames[groupkey + ''];
        if (info) {
            for (let i = 0; i < info.length; i++) {
                if (info[i].uid == uid) {
                    return info[i].nickname;
                }
            }
        }
        return null;
    }

    static getShowName(user, chatkey) {
        if (!user) {
            return null;
        }
        let alias = IMApp.getAlias(user.uid);
        if (alias && alias != '') {
            return alias;
        }

        if (chatkey && IMApp.checkIsGroup(chatkey)) {
            let groupNickName = IMApp.getGroupNickName(chatkey, user.uid);
            if (groupNickName) {
                return groupNickName;
            }
        }
        if (IMApp.user.uid == user.uid) {
            return IMApp.user.nickname;
        }

        return user.nickname;
    }

    static generateMsgOut(msgtype, content, chatkey, isLoaded = false, msgState = 1, user = IMApp.user) {
        let isGroup = IMApp.checkIsGroup(chatkey);
        let chatmsgno = 0;
        // IMConversation.getAllMessage(chatkey, obj => {
        //     if (obj && obj.length > 0) {
        //         chatmsgno = obj[obj.length - 1].chatmsgno;
        //     }
        // }, false);


        chatmsgno = chatmsgno + 0.0000001;
        let m = {
            chatkey: chatkey,
            chatmsgno: chatmsgno,
            msgtype: msgtype,
            uid: user.uid,
            nickname: user.nickname,
            headurl: user.headurl,
            msgtime: IMApp.getCurTime(),
            content: content,
            isGroup: isGroup,
            otherid: IMApp.getOtherId(chatkey, IMApp.user.uid),
            isLoaded: isLoaded,
            clientkey: chatmsgno,
            msgState: msgState,
            snaptime: IMApp.getSnapTime(chatkey),
            myReadTime: IMApp.getCurTime(),
        };
        IMConversation.addMessage([m], () => {
            SingleCountEmitter.emit('notifyConversationListRefresh');
            if (msgState == 1) {
                setTimeout(() => {
                    IMConversation.refreshMessage(m, 2);
                    SingleCountEmitter.emit('MSG_STATE_REFRESH' + chatmsgno, 2);
                }, IMApp.msg_send_loading_time);
            }
        });
        return m;
    }

    static getDeleteMsgNO(chatkey) {
        return IMApp.deleteMsgList[chatkey];
    }

    static removeDeleteMsgNo(chatkey) {
        IMApp.deleteMsgList[chatkey] = null;
    }

    static isSnap(m) {
        if (m.snaptime && m.myReadTime && m.msgtype < 10000) {
            if (IMApp.getCurTime() - m.myReadTime > m.snaptime) {
                return true;
            }
        }
        return false;
    }

    static getChatName(conversationId) {
        return 'chat_' + conversationId + '_' + IMApp.user.uid;
    }

    static getText(item, chatkey = IMApp.conversationId) {
        if (item.msgtype == MessageType.CENTER_TIP_SCREENSHOT) {
            if (IMApp.user.uid == item.uid) {
                return '您对当前页面发起了截图';
            } else {
                return ("'" + IMApp.getShowName(item, chatkey) + "'对当前页面发起了截图");
            }
        } else if (item.msgtype == MessageType.CENTER_TIP_SCREENSHOT_OPEN) {
            let content = JSON.parse(item.content);
            if (IMApp.user.uid == content.uid) {
                return content.screenshot == 1 || content.screenshot == 3 ? '您开启了截图提醒' : '您关闭了截图提醒';
            } else {
                return ("'" + IMApp.getShowName(item, chatkey) + "'" + (content.screenshot == 1 || content.screenshot == 3 ? '开启了截图提醒' : '关闭了截图提醒'));
            }
        }
    };


    static buildMessage(chatkey, chatmsgno, content, isGroup, msgtype) {
        return {
            chatkey: chatkey,
            chatmsgno: chatmsgno,
            content: content,
            headurl: IMApp.user.headurl,
            isGroup: isGroup,
            msgtime: IMApp.getCurTime(),
            msgtype: msgtype,
            nickname: IMApp.user.nickname,
            otherid: IMApp.getOtherId(chatkey, IMApp.user.uid),
            snaptime: IMApp.getSnapTime(chatkey),
            uid: IMApp.user.uid
        }
    }

    static buildTexMessage(chatkey, chatmsgno, content, isGroup) {
        return IMApp.buildMessage(chatkey, chatmsgno, content, isGroup, MessageType.TXT);
    }

    static isMe(uid) {
        return IMApp.user.uid == uid;
    }

    static logout() {
        IMSocketMgr.closeWebSocket();
    }
}